exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*! _variables 07/02/2018  // (C) IHG. All rights reserved. */.brand-logo-container{height:47px;width:47px}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/brand-logo/brand-logo.component.scss
// module id = ./src/main/webapp/stay-mgmt/app/components/brand-logo/brand-logo.component.scss
// module chunks = 0